export default __webpack_public_path__ + "static/media/github.401b9193.svg";